import React from 'react';
import BottomStickyAppDownloadBanner from '../../components/BottomStickyAppDownloadBanner';
import GlobalHeader from '../../components/legacy/common/GlobalHeader';
import GlobalFooter from '../../components/GlobalFooter';
import type {SiteMetadata} from '../../../gatsby-config';
import type {MarkdownQuery} from '../PageTemplate';

type Props = MarkdownQuery['markdownRemark'] & {
  appStoreUrl: string;
  googlePlayUrl: string;
  siteMetadata: SiteMetadata;
  unifiedStoreUrl: string;
};

/**
 * LegacyTermsTemplate
 * The template of terms pages
 * @returns {React.JSX.Element}
 */
export default function LegacyTermsTemplate({
  appStoreUrl,
  googlePlayUrl,
  siteMetadata,
  html,
  unifiedStoreUrl,
}: Props) {
  return (
    <>
      <div className="Terms">
        <GlobalHeader
          appStoreUrl={appStoreUrl}
          currentPath="/"
          googlePlayUrl={googlePlayUrl}
        />
        <div className="Terms_body">
          <div className="Markdown" dangerouslySetInnerHTML={{__html: html}} />
        </div>
        <GlobalFooter
          appStoreUrl={appStoreUrl}
          googlePlayUrl={googlePlayUrl}
          siteMetadata={siteMetadata}
        />
      </div>
      <BottomStickyAppDownloadBanner unifiedStoreUrl={unifiedStoreUrl} />
    </>
  );
}
